import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'

export const useHandbooksDeprecation = () => {
  const currentWorkspace = useCurrentWorkspace()

  return !currentWorkspace?.has_old_handbooks
}
